module.exports = __webpack_public_path__ + "img/05.6fc7be1a.jpg";